import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MDBCol, MDBContainer, MDBRow } from "mdbreact";
import React, { useEffect, useState } from "react";
import {
  Button,
  DateTimePicker,
  FileSelector,
  Option,
  Picklist,
  Textarea,
} from "react-rainbow-components";
import { Link, useHistory } from "react-router-dom";
import { DefaultDateTime } from "../shared/DateTime";
import { DateTimeFormatter } from "../shared/DateTimeFormatter";
import ShowNotification from "../shared/Notification";
import { RequestInit } from "../shared/RequestInit";

interface editPodcast {
  location: {
    state: {
      Id: number;
      titre: string;
      description: string;
      date_enregistrement: string;
      photo: string;
      jour: string;
      emission: string;
    };
  };
}

const EditPodcast = (props: editPodcast) => {
  const [Titre, setTitre] = useState<string>(props.location.state.titre);
  const [Description, setDescription] = useState<string>(
    props.location.state.description
  );
  const [Podcast, setPodcast] = useState<Blob | string>("");
  const [Image, setImage] = useState<Blob | string>(props.location.state.photo);
  const [date_denregistrement, setdate_denregistrement] = useState<string>(
    props.location.state.date_enregistrement
  );
  const [UploadePodcast, setUploadePodcast] = useState<string>("");
  const [UploadeImage, setUploadeImage] = useState<string>("");
  const [AllDropDown, setAllDropDown] = useState<[]>([]);
  const [DropdownState, setDropdownState] = useState<any>({
    name: `${props.location.state.emission.toLowerCase()}`,
    label: `${props.location.state.emission.toLowerCase()}`,
  });
  const [DropDown, setDropDown] = useState<[]>([]);
  const [Emission, setEmission] = useState<any>({
    name: "",
    label: "",
  });

  const [errorTitre, setErrorTitre] = useState<string>("");
  const [errorDescription, setErrorDescription] = useState<string>("");
  const [errorPodcast, setErrorPodcast] = useState<string>("");
  const [UploadError, setUploadError] = useState<boolean>(false);
  const [errorImage, setErrorImage] = useState<string>("");
  const [pending, setPending] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();

  const verifyInput = () => {
    /* initial */
    let isGood: boolean = true;
    if (Titre === "") {
      setErrorTitre("Le titre est obligatoire");
      isGood = false;
    }
    if (Description === "") {
      setErrorDescription("La description est obligatoire");
      isGood = false;
    }
    if (Image === "") {
      setErrorImage(`L'image est obligatoire`);
      isGood = false;
    }
    /* if required fields are not empty, return true otherwise return false */
    if (isGood) {
      return true;
    } else {
      return false;
    }
  };
  const resetInputErrors = () => {
    setUploadError(false);
    setErrorTitre("");
    setErrorPodcast("");
    setErrorImage("");
    setErrorDescription("");
  };

  const fetchtDropDown = async () => {
    await fetch(
      "https://admin.radioemotion.be/api/emission/dropdown",
      RequestInit as RequestInit
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.response === true) {
          setAllDropDown(response.data);
          setDropDown(response.data);
          setPending(false);
        }
      })
      .catch((err) => {
        setPending(false);
      });
  };

  const filterDropdown = () => {
    const result: any = AllDropDown?.filter(
      (dropdown: any) =>
        dropdown.emission.toLowerCase() ==
        `${props.location.state.emission.toLowerCase()}`
    );
    return result[0].Id;
  };
  const updatePodcast = async () => {
    resetInputErrors();
    if (verifyInput() === true) {
      setLoading(true);
      const formData = new FormData();
      if (Podcast !== "") {
        formData.append("audio", Podcast);
      }
      if (Image !== props.location.state.photo) {
        formData.append("file", Image);
      }
      formData.append(
        "data",
        JSON.stringify({
          id: props.location.state.Id,
          titre: Titre,
          description: Description,
          date_enregistrement: date_denregistrement,
          emission_fk:
            Emission.Id === undefined ? filterDropdown() : Emission.Id,
          image: Image === props.location.state.photo ? null : Image,
        })
      );
      const requestOptions = {
        method: "PUT",
        credentials: "include",
        headers: {
          Accept: "application/json",
        },
        body: formData,
      };
      await fetch(
        "https://admin.radioemotion.be/api/podcast/update",
        requestOptions as RequestInit
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.response === true) {
            history.push({
              pathname: "/podcast/list",
              state: { passed: true, message: `L'emission a été mise à jour ` },
            });
          } else {
            setUploadError(true);
            setLoading(false);
          }
        })
        .catch((err) => {
          setUploadError(true);
          setLoading(false);
        });
    }
  };
  useEffect(() => {
    fetchtDropDown();
  }, []);

  console.log(props.location.state);
  return (
    <>
      {UploadError ? (
        <>
          <ShowNotification
            icon="times"
            iconClassName="color-red"
            bodyClassName="color-red background-color-red text-white"
            autohide={5000}
            title=""
            message="Une erreur s'est produite"
            text="maintenant"
          />
        </>
      ) : null}
      <MDBContainer className="min-h-100vh">
        <MDBRow className="mb-5 mt-2">
          <Link to="/">
            <Button variant="neutral" className="mt-2">
              <FontAwesomeIcon icon={faHome} className="py-1" size="2x" />
            </Button>
          </Link>
        </MDBRow>
        <MDBRow>
          <form encType="multipart/form-data" className="w-100">
            <MDBRow around>
              <MDBCol md={"6"} xs={"12"} sm={"12"}>
                <Textarea
                  id="podcastCreateTitre"
                  label="Titre du podcast"
                  rows={2}
                  placeholder="Titre du podcast"
                  grow={true}
                  onChange={(e) => {
                    setTitre(e.target.value);
                    {
                      e.target.value === ""
                        ? setErrorTitre("Le titre est obligatoire")
                        : setErrorTitre("");
                    }
                  }}
                  value={Titre}
                  error={errorTitre}
                />
              </MDBCol>
              <MDBCol md={"6"} xs={"12"} sm={"12"}>
                <Textarea
                  id="podcastCreateDescription"
                  label="Description du podcast"
                  rows={2}
                  placeholder="Description du podcast"
                  grow={true}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    {
                      e.target.value === ""
                        ? setErrorDescription("La description est obligatoire")
                        : setErrorDescription("");
                    }
                  }}
                  value={Description}
                  error={errorDescription}
                />
              </MDBCol>
            </MDBRow>
            <MDBRow around className="mt-5">
              <MDBCol md={"4"} xs={"12"} sm={"12"}>
                <DateTimePicker
                  value={date_denregistrement}
                  label="Date du Podcast"
                  locale="fr"
                  formatStyle={"large"}
                  onChange={(value) =>
                    setdate_denregistrement(DateTimeFormatter(value, true))
                  }
                  hour24={true}
                />
              </MDBCol>
              <MDBCol md={"4"} xs={"12"} sm={"12"} className="">
                <Picklist
                  placeholder="Nom de l'emission"
                  label="Nom de l'emission"
                  name="Nom de l'emission"
                  variant="default"
                  value={DropdownState}
                  onChange={(value) => {
                    setDropdownState({
                      name: value.label,
                      label: value?.value,
                    });
                    setEmission({
                      Id: value.name,
                    });
                  }}
                >
                  {DropDown &&
                    DropDown.map(
                      (
                        data: {
                          Id: number;
                          emission: string;
                          jour: string;
                        },
                        index: number
                      ) => (
                        <Option
                          key={index}
                          name={`${data.Id}`}
                          label={`${data.emission}`}
                          value={`${data.emission}`}
                        />
                      )
                    )}
                </Picklist>
              </MDBCol>
            </MDBRow>
            <MDBRow around className="mt-5">
              <MDBCol md={"4"} xs={"12"} sm={"12"}>
                <FileSelector
                  label="Fichier mp3 du podcast"
                  placeholder="Glisser & déposer ou cliquer pour parcourir"
                  bottomHelpText="Selectionez seulement un fichier"
                  onChange={(value) => {
                    setPodcast(value[0]);
                    setUploadePodcast(URL.createObjectURL(value[0]));
                  }}
                  accept=".mp3"
                  error={errorPodcast}
                />
              </MDBCol>
              <MDBCol md={"4"} xs={"12"} sm={"12"}>
                <FileSelector
                  label="Pochette du podcast"
                  placeholder="Glisser & déposer ou cliquer pour parcourir"
                  bottomHelpText="Selectionez seulement un fichier"
                  onChange={(value) => {
                    setImage(value[0]);
                    setUploadeImage(URL.createObjectURL(value[0]));
                  }}
                  error={errorImage}
                />
              </MDBCol>
            </MDBRow>
          </form>
        </MDBRow>
        <MDBRow end>
          <Button
            isLoading={loading}
            label="Mettre à jour"
            onClick={() => updatePodcast()}
            variant="brand"
            className="mt-2 mb-4 font-weight-bold"
          />
        </MDBRow>
      </MDBContainer>
    </>
  );
};

export default EditPodcast;
